/**
 * Animated "AI Crystal" — pure CSS/SVG geometric construct.
 * No 3D library; renders reliably across browsers and React versions.
 */
export default function AICrystal({ className = "" }) {
  return (
    <div data-testid="ai-crystal-3d" className={`relative ${className}`}>
      <style>{`
        @keyframes ai-spin { 0% { transform: rotate(0deg); } 100% { transform: rotate(360deg); } }
        @keyframes ai-spin-rev { 0% { transform: rotate(360deg); } 100% { transform: rotate(0deg); } }
        @keyframes ai-pulse { 0%, 100% { opacity: 0.4; transform: scale(1); } 50% { opacity: 0.9; transform: scale(1.08); } }
        @keyframes ai-bob { 0%, 100% { transform: translateY(0); } 50% { transform: translateY(-8px); } }
      `}</style>
      <div className="absolute inset-0 rounded-full bg-[#F97316]/15 blur-3xl" />
      <div className="relative w-full h-full flex items-center justify-center" style={{ animation: "ai-bob 5s ease-in-out infinite" }}>
        <svg viewBox="-100 -100 200 200" className="w-full h-full">
          <defs>
            <radialGradient id="coreGrad" cx="50%" cy="50%" r="50%">
              <stop offset="0%" stopColor="#F97316" stopOpacity="0.95" />
              <stop offset="60%" stopColor="#F97316" stopOpacity="0.5" />
              <stop offset="100%" stopColor="#FB923C" stopOpacity="0.0" />
            </radialGradient>
          </defs>

          {/* Outer hex ring */}
          <g style={{ transformOrigin: "0 0", animation: "ai-spin 18s linear infinite" }}>
            <polygon
              points="0,-80 70,-40 70,40 0,80 -70,40 -70,-40"
              fill="none"
              stroke="#FB923C"
              strokeWidth="1"
              strokeOpacity="0.55"
            />
            {[[0,-80],[70,-40],[70,40],[0,80],[-70,40],[-70,-40]].map(([x,y],i)=>(
              <circle key={i} cx={x} cy={y} r="3" fill="#FB923C" />
            ))}
          </g>

          {/* Middle ring */}
          <g style={{ transformOrigin: "0 0", animation: "ai-spin-rev 14s linear infinite" }}>
            <polygon
              points="0,-55 48,-27 48,27 0,55 -48,27 -48,-27"
              fill="none"
              stroke="#F97316"
              strokeWidth="1"
              strokeOpacity="0.7"
            />
            {[[0,-55],[48,-27],[48,27],[0,55],[-48,27],[-48,-27]].map(([x,y],i)=>(
              <circle key={i} cx={x} cy={y} r="2.5" fill="#F97316" />
            ))}
          </g>

          {/* Inner triangle */}
          <g style={{ transformOrigin: "0 0", animation: "ai-spin 10s linear infinite" }}>
            <polygon
              points="0,-30 26,15 -26,15"
              fill="none"
              stroke="#22C55E"
              strokeWidth="1"
              strokeOpacity="0.7"
            />
          </g>

          {/* Connecting lines */}
          <g stroke="#F97316" strokeWidth="0.4" strokeOpacity="0.4">
            <line x1="0" y1="-80" x2="0" y2="80" />
            <line x1="-70" y1="-40" x2="70" y2="40" />
            <line x1="70" y1="-40" x2="-70" y2="40" />
          </g>

          {/* Pulsing core */}
          <circle cx="0" cy="0" r="40" fill="url(#coreGrad)" style={{ animation: "ai-pulse 2.4s ease-in-out infinite" }} />
          <circle cx="0" cy="0" r="6" fill="#F97316" />
          <circle cx="0" cy="0" r="14" fill="none" stroke="#F97316" strokeOpacity="0.6" />
        </svg>
      </div>
    </div>
  );
}
